'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var MOLECULE_NAME = 'legal-content';

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph && paragraph.text) {
    return _react2.default.createElement(
      'p',
      { className: MOLECULE_NAME + '__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderTable = function renderTable(table) {
  if (table && table.text) {
    return _react2.default.createElement(
      'div',
      { className: MOLECULE_NAME + '__table' },
      htmlToReactParser.parse(table.text)
    );
  }
  return null;
};

var LegalContent = function LegalContent(props) {
  var className = props.className,
      content = props.content;
  var paragraph = content.paragraph,
      table = content.table,
      paragraph2 = content.paragraph2;


  var moleculeClasses = (0, _classnames2.default)(MOLECULE_NAME, className);

  return _react2.default.createElement(
    'div',
    { className: moleculeClasses },
    renderParagraph(paragraph),
    renderTable(table),
    renderParagraph(paragraph2)
  );
};

exports.default = LegalContent;


LegalContent.propTypes = {
  content: _propTypes2.default.shape({
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    table: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    paragraph2: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

LegalContent.defaultProps = {
  content: {
    paragraph: {
      text: '2,000 characters maximum is recommended.'
    },
    table: {
      text: '<table class="ppvx_table"><tbody><tr><td><p>Currency</p></td><td><p>Fee</p></td></tr><tr><td><p>U.S. Dollar</p></td><td><p>0.30 USD</p></td></tr><tr><td><p>Euro</p></td><td><p>0.35 EUR</p></td></tr></tbody></table>'
    },
    paragraph2: {
      text: '2,000 characters maximum is recommended.'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/legal-content/jsx/LegalContent.js
// module id = 667
// module chunks = 4